<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: 80px;width: auto;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Clientes
    v-dialog(v-model='dialog', persistent max-width='900px')
      v-container(style='background-color:white !important;max-width: 900px;')
        v-card-title.justify-center
          span.headline Cliente
        div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs8)
                v-form(enctype="multipart/form-data")

                  v-text-field(outline
                    v-model="form.email"
                    prepend-inner-icon="mail"
                    label="Correo electrónico:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                  v-text-field(outline
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    v-model="form.password"
                    prepend-inner-icon="lock"
                    label="Contraseña:"
                    style="height: 56px;width: 89%;margin: 0px 32px 10px;")

                  div(style="display: flex;justify-content: center;")
                      v-btn(style="background:#0093dd;border-radius:10px;", @click.native='save' v-if="!loading") Guardar
                      v-progress-circular(indeterminate='', v-if="loading" style='border-radius: 10px;color: #0093dd;')
                      v-btn(style="background:black;;border-radius:10px;", @click.native='close' v-if="!loading") Salir
    v-flex(xs12)
      v-card(flat='')
        v-flex(xs12)
          div(style="margin-top:20px")
            v-flex(xs12)
              v-layout(wrap)
                v-flex(xs6 style='display: flex;align-items: center;')
                  v-text-field(v-model='search2' label='Buscar' style='width:100%;')
                  v-btn.mx-0(icon, @click='busqinit(search2)', style='background: white;border-radius: 100%;margin-left:10px !important;margin-top: 2px;').elevation-4
                    v-icon(color='#ff6500' style='font-size: 1.70rem;') search
          v-layout(align-start='', justify-start='', row='', fill-height='')
            v-flex(xs12 style='margin-top: 5px;')
              v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                  v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                      span.white--text Lista de Clientes
              v-data-table.elevation-1(:headers='headers' :items="clientes" style="margin-top: 5px;" hide-actions, :pagination.sync="pagination")
                template(slot='items', slot-scope='props')
                  td(v-if='props.item.co_cli && props.item.co_cli.trim() !== ""') {{ props.item.co_cli }}
                  td(v-else) N/A
                  td(v-if='props.item.cli_des && props.item.cli_des.trim() !== ""') {{ props.item.cli_des }}
                  td(v-else) N/A
                  td(v-if='props.item.rif && props.item.rif.trim() !== ""') {{ props.item.rif }}
                  td(v-else) N/A
                  td(v-if='props.item.telefonos && props.item.telefonos.trim() !== ""') {{ props.item.telefonos }}
                  td(v-else) N/A
                  td(v-if='props.item.email && props.item.email.trim() !== ""') {{ props.item.email }}
                  td(v-else) N/A
                  td.justify-start.layout.px-0
                    v-btn(v-if='mod').mx-0(icon, @click='editItem(props.item)', style='margin-top: -9px;')
                        v-icon(style='color: #04b204 !important') edit
              v-card
                v-flex(xs12)
                  v-layout(wrap='')
                    v-flex(xs6)
                    v-flex(xs5 style='display: flex;justify-content: flex-end;align-items: center;')
                      div(style='margin: 10px;')
                        span {{min}} a {{max}} elementos
                      div(style='margin: 2px;')
                        v-btn.mx-0(id='prev' icon, @click='prev()', style='background: gainsboro;border-radius:50%;' hidden)
                          v-icon(color='black' style='font-size: 1.8rem;') arrow_left
                      div(style='margin: 2px;' v-for='(item,index) in listado')
                        v-btn.mx-0(:id='"num"+item', @click='seleccion(item)' icon, v-bind:class="{ numActive: actual == item,  numAInactivo: actual != item}")
                          span(style='font-weight: bold;color:black;') {{item}}
                      div(style='margin: 2px;')
                        v-btn.mx-0(id='next' icon, @click='next()', style='background: gainsboro;border-radius:50%;')
                          v-icon(color='black' style='font-size: 1.8rem;') arrow_right
                    v-flex(xs1)
                    v-flex(xs11 style='display: flex;justify-content: flex-end;')
                      v-flex#sll(xs2 style='display: flex;justify-content: flex-end;align-items: center;margin-right: 17px;')
                        v-select(id="paginas"
                        outline
                        @change='seleccion(selpag)'
                        :items="paginas"
                        v-model="selpag"
                        dense
                        required
                        label="Página:")
    //===========================================================Modal Espera==============================================================================================
    v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
      v-container(style='max-width: 400px;background:#f1f2f1')
        div(style="margin-top: 20px;")
            v-flex(xs12 sm12)
              v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h4.black--text  Esperando Respuesta del Servidor.!!
                v-flex(xs12)
                    div(style='display: flex;justify-content: center;').text-xs-center
                      img(src='../assets/waiting.gif', with='200' ,height='150')
                v-flex(xs12)
                  v-card-title(style="padding: 7px;").justify-center
                    h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mClientes",
  components: {},
  data: () => ({
    search2: "",
    dialog4: false,
    dialog: false,
    show1: false,
    listado: [],
    paginas: [],
    selpag: "",
    min: 0,
    max: 0,
    clientes: [],
    editedIndex: -1,
    pagination: {
      rowsPerPage: 20
    },
    loading: false,
    ruta: server + ":" + port,
    headers: [
      { text: "Código", value: "co_cli" },
      { text: "Cliente", value: "cli_des" },
      { text: "Rif", value: "rif" },
      { text: "Teléfono", value: "telefonos" },
      { text: "Email", value: "email" },
      { text: "Acciones" }
    ],
    form: {
      co_cli: "",
      email: "",
      password: ""
    },
    defaultForm: {
      co_cli: "",
      email: "",
      password: ""
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.webamairca.permisos.length; i++) {
        if (this.$store.state.webamairca.permisos[i].ruta === "Clientes") {
          for (
            let j = 0;
            j < this.$store.state.webamairca.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.webamairca.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    busqinit(item) {
      this.dialog4 = true
      document.getElementById("prev").hidden = true;
      document.getElementById("next").hidden = false;
      Api.get(
        "cliente/sinseleccion?search=" + item)
        .then((res) => {
          this.clientes = [];
          this.listado = [];
          this.clientes = res.data.resultado;
          this.max = this.productos.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            this.actual = 1;
            this.selpag = 1;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    seleccion(item) {
      this.dialog4 = true;
      Api.get(
        "cliente/pag?search=" +
          this.search2 +
          "&id=" +
          item
      )
        .then((res) => {
          this.clientes = []
          this.dialog4 = false;
          this.max = res.data.max;
          this.min = this.max - res.data.resultado.length;
          this.clientes = res.data.resultado;
          for (let i = 1; i <= res.data.paginas; i++) {
            this.paginas.push(i);
          }
          document.getElementById("next").hidden = false;
          document.getElementById("prev").hidden = false;
          if (this.min === 0) {
            document.getElementById("prev").hidden = true;
          }
          if (res.data.tope === true) {
            document.getElementById("next").hidden = true;
          }
          let a = item;
          this.listado = [];
          for (let i = 0; i < 4; i++) {
            if (a <= res.data.pag) {
              this.listado.push(a);
            }
            a++;
          }
          this.$nextTick(() => {
            this.actual = item;
            this.selpag = item;
          });
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
    prev() {
      let info = {
        estatus: this.seleccionado,
        max: this.min,
        ult: false,
        num: null,
      };
      let dat = this.actual - 1;
      if (dat < this.listado[0]) {
        info.ult = true;
        info.num = dat;
      }
      this.dialog4 = true;
      Api.post(
        "cliente/prev?search=" +
          this.search2,
        info
      )
        .then((res) => {
          if (res.data.resultado.length > 0) {
            this.clientes = []
            this.max = res.data.max + 20;
            this.min = res.data.max;
            this.clientes = res.data.resultado;
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            document.getElementById("next").hidden = false;
            if (res.data.tope === true) {
              document.getElementById("prev").hidden = true;
            }
          }
          if (info.ult) {
            let a = this.listado[0] - 5;
            this.listado = [];
            if (a < 0) {
              a = 0;
              document.getElementById("prev").hidden = true;
            }
            for (let i = 0; i < 4; i++) {
              a++;
              if (a <= res.data.pag) {
                this.listado.push(a);
              }
            }
            this.$nextTick(() => {
              this.actual = this.actual - 1;
              this.selpag = this.actual;
            });
          } else {
            this.actual = this.actual - 1;
            this.selpag = this.actual;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          this.dialog4 = false;
          console.log(err);
        });
    },
    next() {
      let info = {
        estatus: this.seleccionado,
        max: this.max,
        ult: false,
        num: null,
      };
      let dat = this.actual + 1;
      if (dat > this.listado[this.listado.length - 1]) {
        info.ult = true;
        info.num = dat;
      }
      this.dialog4 = true;
      Api.post(
        "cliente/next?search=" +
          this.search2,
        info
      )
        .then((res) => {
          if (res.data.resultado.length > 0) {
            this.clientes = []
            this.max = res.data.max;
            this.min = this.max - res.data.resultado.length;
            this.clientes = res.data.resultado;
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            document.getElementById("prev").hidden = false;
            if (res.data.tope === true) {
              document.getElementById("next").hidden = true;
            }
          }
          if (info.ult) {
            let a = this.listado[this.listado.length - 1];
            this.listado = [];
            for (let i = 0; i < 4; i++) {
              a++;
              if (a <= res.data.pag) {
                this.listado.push(a);
              }
            }
            this.$nextTick(() => {
              this.actual = this.actual + 1;
              this.selpag = this.actual;
            });
          } else {
            this.actual = this.actual + 1;
            this.selpag = this.actual;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          this.dialog4 = false;
          console.log(err);
        });
    },
    editItem(item) {
      this.editedIndex = this.clientes.indexOf(item);
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key].trim();
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    close() {
      this.loading = false;
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
      this.editedIndex = -1;
    },
    save() {
      if (this.form.email || this.form.password) {
        this.loading = true;
        Api.put("cliente/credenciales", this.form)
          .then(res => {
            if (res.data.error) {
              this.$swal.fire("¡Atención!", res.data.error, "error");
              this.loading = false;
            } else {
              this.$swal.fire(
                "Felicidades.!",
                "Modificación realizada exitosamente.",
                "success"
              );
              for (let i = 0; i < this.clientes.length; i++) {
                if (this.clientes[i]._id === res.data._id) {
                  this.$set(this.clientes, i, res.data);
                }
              }
              this.close();
            }
          })
          .catch(() => {
            this.loading = false;
            this.$swal.fire(
              "¡Atención!",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
          });
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Estimado usuario, para continuar con la operación debe completar al menos uno de los campos solicitados.",
          "error"
        );
      }
    },
    initialize() {
      this.close();
      this.dialog4 = true;
      Api.get("cliente/sinseleccion")
        .then((res) => {
          this.clientes = res.data.resultado;
          this.max = this.clientes.length;
          if (this.max === 0) {
            this.min = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.min = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.min = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            this.selpag = 1;
            this.actual = 1;
          }
          this.dialog4 = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialog4 = false;
        });
    },
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
.numActive {
  background-color: #adadad;
  border-radius: 50%;
}
.numAInactivo {
  background-color: gainsboro;
  border-radius: 50%;
}
</style>
